import React, { useState } from "react"
import { SendMessageContainerContextProps } from "../containers/talktocarrot/SendMessageFormContainer"
import CarrotClient from "carrot-api"
import Settings from "../../utils/CarrotConfig"
import { useDispatch, useSelector } from "react-redux"
import { getUserInfo } from "../../reducers/userInfo"
import { FormProvider, useForm } from "react-hook-form"
import { HttpErrors } from "../../utils/HttpErrors"
import { signOut } from "../../actions/loginActions"
import { reportError } from "../../utils/ErrorReporting"
import { TalkToCarrotSendMessageForm } from "./util/TalkToCarrotSendMessageForm"

const SendMessageContext = React.createContext<SendMessageContainerContextProps>({})
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const getInputOrSelectEmail = (email) => {
  if (typeof email === "string") {
    return email
  }
  return email?.id
}

enum zendeskSubjects {
  I_NEED_HELP = "I need help (Talk to Carrot)",
  SEND_A_MESSAGE = "I have a question"
}

const SendMessage = ({ subject }) => {
  const { personalEmail, email: employeeEmail, partnerEmail } = useSelector(getUserInfo)
  const email = personalEmail || employeeEmail
  const [sentFromPartnerEmail, setSentFromPartnerEmail] = useState(false)
  const [sent, setSent] = useState(false)
  const dispatch = useDispatch()

  const options = [
    {
      label: email,
      subLabel: personalEmail ? " (your preferred contact email)" : " (your account email)",
      id: email
    },
    {
      label: partnerEmail,
      subLabel: "(your partner's email)",
      id: partnerEmail
    }
  ]

  const formMethods = useForm({
    mode: "onChange",
    defaultValues: {
      message: "",
      defaultMessage: "Member sent a message with no content",
      email: ""
    }
  })
  const { handleSubmit, setError } = formMethods

  // eslint-disable-next-line
  // @ts-ignore
  const onSubmit = handleSubmit(async ({ email: emailOption, message, defaultMessage }) => {
    try {
      const email = getInputOrSelectEmail(emailOption)
      const sendFromPartner = email === partnerEmail
      const sendMessage = message ? message : defaultMessage
      setSentFromPartnerEmail(sendFromPartner)
      await client.sendTalkToCarrotMessage(sendMessage, subject, sendFromPartner, null)
    } catch (error) {
      if (error.name === HttpErrors.UNAUTHORIZED) {
        dispatch(signOut())
        return
      }
      reportError(error)

      setError("message", {
        type: "internalError",
        message: "We ran into an issue while sending your message. Please try again."
      })
      return
    }
    setSent(true)
  })

  const context = {
    onSubmit,
    sent,
    options,
    employeeEmail: email,
    personalEmail: personalEmail,
    partnerEmail: partnerEmail,
    sentFromPartnerEmail: sentFromPartnerEmail
  }

  return (
    <SendMessageContext.Provider value={context}>
      <FormProvider {...formMethods}>
        <TalkToCarrotSendMessageForm />
      </FormProvider>
    </SendMessageContext.Provider>
  )
}

export { SendMessage, SendMessageContext, zendeskSubjects }
